const data = {
	"body": "<circle cx=\"12\" cy=\"12\" r=\"1.5\" fill=\"currentColor\"/><path fill=\"currentColor\" d=\"M21.87 11.5c-.64-1.11-4.16-6.68-10.14-6.5c-5.53.14-8.73 5-9.6 6.5a1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 0 0 0-1Zm-9.87 4a3.5 3.5 0 1 1 3.5-3.5a3.5 3.5 0 0 1-3.5 3.5Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
